export const serviceConnection = [
	// Подключение
	{
		name: 'Подключение интернет-эквайринга CloudPayments',
		location: 'Подключение',
		url: '/integration#block1',
	},
	{
		name: 'Порядок подключения',
		location: 'Подключение',
		url: '/integration#block2',
	},
	{
		name: 'Пошаговая инструкция по подключению интернет-эквайринга',
		location: 'Подключение',
		url: '/integration#block2Title1',
	},
	{
		name: 'Подключение интернет-эквайринга для нерезидентов РФ',
		location: 'Подключение',
		url: '/integration#block3',
	},
	{
		name: 'Как подключить интернет-эквайринг на сайт или в мобильное приложение?',
		location: 'Подключение',
		url: '/integration#block4',
	},
	{
		name: 'Платежный виджет',
		location: 'Подключение',
		url: '/integration#block4Title1',
	},
	{
		name: 'Checkout-скрипт',
		location: 'Подключение',
		url: '/integration#block4Title2',
	},
	{
		name: 'По ссылке',
		location: 'Подключение',
		url: '/integration#block4Title3',
	},
	{
		name: 'QR-код',
		location: 'Подключение',
		url: '/integration#block4Title4',
	},
	{
		name: 'Библиотеки и SDK',
		location: 'Подключение',
		url: '/integration#block4Title5',
	},
	{
		name: 'API',
		location: 'Подключение',
		url: '/integration#block4Title6',
	},
	{
		name: 'Модули для CMS',
		location: 'Подключение',
		url: '/integration#block4Title7',
	},
	// Платежный виджет
	{
		name: 'Платежный виджет',
		location: 'Подключение: Платежный виджет',
		url: '/integration/widget#block1',
	},
	{
		name: 'Как работает виджет?',
		location: 'Подключение: Платежный виджет',
		url: '/integration/widget#block2',
	},
	{
		name: 'Адаптация под любой сайт и приложение',
		location: 'Подключение: Платежный виджет',
		url: '/integration/widget#block2Title1',
	},
	{
		name: 'Платежи без редиректа',
		location: 'Подключение: Платежный виджет',
		url: '/integration/widget#block2Title2',
	},
	{
		name: 'Все платежные методы в одном месте',
		location: 'Подключение: Платежный виджет',
		url: '/integration/widget#block2Title3',
	},
	// {
	// 	name: 'Дизайн в фирменном стиле',
	// 	location: 'Подключение: Платежный виджет',
	// 	url: '/integration/widget#block2Title4',
	// },
	{
		name: 'Увеличение импульсных покупок',
		location: 'Подключение: Платежный виджет',
		url: '/integration/widget#block2Title4',
	},
	{
		name: 'Удобные технологии',
		location: 'Подключение: Платежный виджет',
		url: '/integration/widget#block2Title5',
	},
	// Checkout скрипт
	{
		name: 'Скрипт Checkout',
		location: 'Подключение: Checkout скрипт',
		url: '/integration/checkout-script#block1',
	},
	{
		name: 'Как работает Checkout скрипт?',
		location: 'Подключение: Checkout скрипт',
		url: '/integration/checkout-script#block2',
	},
	{
		name: 'Адаптивный дизайн',
		location: 'Подключение: Checkout скрипт',
		url: '/integration/checkout-script#block2Title1',
	},
	{
		name: 'Независимое управление',
		location: 'Подключение: Checkout скрипт',
		url: '/integration/checkout-script#block2Title2',
	},
	{
		name: 'Увеличение ценности бренда',
		location: 'Подключение: Checkout скрипт',
		url: '/integration/checkout-script#block2Title3',
	},
	{
		name: 'Повышение платежной конверсии',
		location: 'Подключение: Checkout скрипт',
		url: '/integration/checkout-script#block2Title4',
	},
	{
		name: 'Быстрая установка',
		location: 'Подключение: Checkout скрипт',
		url: '/integration/checkout-script#block3',
	},
	// SDK для Android
	{
		name: 'Прием платежей в мобильном приложении Android',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block1',
	},
	{
		name: 'Возможности SDK для Android',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block2',
	},
	{
		name: 'Токенизация карт',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block2Title1',
	},
	{
		name: 'Холдирование средств',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block2Title2',
	},
	{
		name: 'Автоплатежи',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block2Title3',
	},
	{
		name: 'Платежные формы без редиректа',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block2Title4',
	},
	{
		name: 'Соответствие PCI DSS',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block2Title5',
	},
	{
		name: 'Международные платежи ',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block2Title6',
	},
	{
		name: 'Как подключить платежи через мобильный SDK для Android',
		location: 'Подключение: SDK для Android',
		url: '/integration/sdk/android#block3',
	},
	// SDK для iOS
	{
		name: 'Прием платежей в мобильном приложении iOS',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block1',
	},
	{
		name: 'Возможности SDK для iOS',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block2',
	},
	{
		name: 'Токенизация карт',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block2Title1',
	},
	{
		name: 'Холдирование средств',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block2Title2',
	},
	{
		name: 'Автоплатежи',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block2Title3',
	},
	{
		name: 'Платежные формы без редиректа',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block2Title4',
	},
	{
		name: 'Соответствие PCI DSS',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block2Title5',
	},
	{
		name: 'Международные платежи',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block2Title6',
	},
	{
		name: 'Как подключить платежи через мобильный SDK для iOS',
		location: 'Подключение: SDK для iOS',
		url: '/integration/sdk/ios#block3',
	},
	// Модули для CMS
	{
		name: 'Модули для CMS',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms#block1',
	},
	{
		name: 'Платежные модули Cloudpayments',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms#block2',
	},
	{
		name: 'Интеграции партнеров',
		location: 'Подключение: Модули для CMS',
		url: '/integration/cms#block3',
	},
];
